export default __webpack_public_path__ + "static/media/reveloFacebook-1200x630.ccd02e0d.jpg";